import DaySeparateSalesStoreManagement from './daySeparateSalesStoreManagement';

export default DaySeparateSalesStoreManagement;
